import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col, FormGroup, Popover, PopoverBody, FormCheckbox, Card, CardHeader, CardBody } from 'shards-react'
import { ResponsiblePrimaryButton } from '../../../components/buttons/ResponsibleAmeButton'
import ActionsConstants from '../../../components/common/mini-app-list-component/actions-constants/ActionsConstants'
import withLoading from '../../../hocs/withLoading/withLoading'

const CheckedActionsList = props => {
    const { isItemChecked, handleToggleUserActions, toggle, handleEditUserActions } = props.actions
    const { allActions, email, slug, checkedActions, opennedDescription } = props.options
    return (
        <Card>
            <CardHeader className="border-bottom">Lista de Actions: {slug}</CardHeader>
            <CardBody>
                <Row>
                    {allActions.map((action, actionKey) => (
                        <Col className="col-sm-12 col-md-6 col-lg-4 col-xl-3" key={actionKey}>
                            <FormGroup className="d-flex align-items-start">
                                <FormCheckbox
                                    className="pr-3"
                                    checked={isItemChecked(action, checkedActions)}
                                    onChange={() => handleToggleUserActions(action)}
                                >
                                    {action.toLowerCase()}
                                </FormCheckbox>
                                <i
                                    style={{ cursor: 'pointer' }}
                                    className="material-icons"
                                    id={`action-description-${actionKey}`}
                                    onClick={() => toggle(`action-description-${actionKey}`)}
                                >
                                    help
                                </i>
                            </FormGroup>
                            <Popover
                                placement="bottom"
                                open={opennedDescription && opennedDescription === `action-description-${actionKey}`}
                                toggle={() => toggle}
                                target={`#action-description-${actionKey}`}
                            >
                                <PopoverBody>{ActionsConstants.get(action.toLowerCase())}</PopoverBody>
                            </Popover>
                        </Col>
                    ))}
                    <hr />
                </Row>
                <Row className="d-flex justify-content-end w-100">
                    <ResponsiblePrimaryButton
                        name="bt_update_user_actions"
                        onClick={() => handleEditUserActions(email)}
                    >
                        Salvar Actions
                    </ResponsiblePrimaryButton>
                </Row>
            </CardBody>
        </Card>
    )
}

CheckedActionsList.propTypes = {
    props: PropTypes.object,
    actions: PropTypes.object,
    options: PropTypes.object,
    allActions: PropTypes.array,
    email: PropTypes.string,
    slug: PropTypes.string,
    checkedActions: PropTypes.array,
    opennedDescription: PropTypes.bool,
    isItemChecked: PropTypes.func,
    handleToggleUserActions: PropTypes.func,
    toggle: PropTypes.func,
    handleEditUserActions: PropTypes.func,
    informations: PropTypes.object,
}

const WrappedComponent = withLoading(CheckedActionsList)

export default WrappedComponent
